<template>
  <div class="pb-16 md:pb-0">
    <div class="flex items-center justify-center">
      <div class="md:text-center space-y-3 max-w-md md:max-w-lg max-w">
        <BaseText type="display" size="2xs">
          <h4>
            Test one plan 7 days for free
          </h4>
        </BaseText>
        <BaseText size="md" class="text-neutral-alpha-650">
          Choose a plan and start your free 7-day trial. Find your next winning ad, and level up your workflow for free without any risk.
        </BaseText>
      </div>
    </div>
    <!-- Interval toggle -->
    <div class="mt-7 mb-4 md:mt-10 md:mb-10 w-full flex items-center justify-center">
      <div ref="intervalContainer" class="w-full md:w-auto relative rounded-lg flex items-center gap-2 p-0.5 border border-neutral-alpha-300 max-w-md">
        <div :style="backgroundStyle" class="absolute z-10 rounded-lg transition-all selected-interval-tag" />
        <button ref="monthly-btn" class="w-1/2 md:w-auto px-2 py-1.5 rounded-lg z-20 transition-colors"
        @click="setInterval('monthly')">
          <BaseText type="label" size="sm" :class="activeInterval === 'monthly' ? 'text-white' : 'text-neutral-alpha-400'">
            Monthly
          </BaseText>
        </button>
        <button ref="annual-btn" class="w-1/2 md:w-auto px-2 py-1.5  z-20 transition-colors flex items-center gap-2 justify-center md:justify-start flex-nowrap whitespace-nowrap"
        @click="setInterval('annual')">
          <BaseText type="label" size="sm" :class="activeInterval === 'annual' ? 'text-white' : 'text-neutral-alpha-400'">
            Annually
          </BaseText>
          <BaseText size="sm" :class="activeInterval === 'annual' ? 'text-white' : 'text-neutral-alpha-400'">
            Save ~15%
          </BaseText>
        </button>
      </div>
    </div>
    <div class="flex flex-col gap-y-3 md:flex-row items-center md:justify-center w-full">
      <DarkProductCard
        v-for="(plan, index) in productCards"
        :key="plan.key"
        :product="plan"
        :is-monthly="activeInterval === 'monthly'"
        :all-products="PRODUCT_ASSETS"
        :active-interval="activeInterval"
        :rounding="index === 0 ? 'left' : index === productCards.length - 1 ? 'right' : 'all'"
        @action="handleNext"
      />
    </div>
    <!-- Enterprise Plan Info -->
    <div class="flex p-5 rounded-2xl md:rounded-lg border border-neutral-alpha-300 mt-3 md:mt-6 h-full">
      <div class="w-full md:w-auto md:border-r border-neutral-alpha-300 md:pr-3 h">
        <BaseText type="label" size="sm" class="text-white uppercase">
          <h5>
            Enterprise
          </h5>
        </BaseText>
        <BaseText size="sm" class="text-neutral-alpha-650 mt-2">
          For large agencies and scaling brand organizations.
        </BaseText>
        <!-- Divider -->
        <div class="hidden md:block h-0 w-full border-t border-neutral-alpha-300 mt-5 mb-4" />
        <div class="space-y-2 mt-5 md:mt-0">
          <BaseText type="display" size="2xs" class="text-white">
            <h5>
              Custom Pricing
            </h5>
          </BaseText>
          <div class="flex items-center gap-1">
            <MoneyCircleIcon class="money-icon" />
            <BaseText type="label" size="sm" class="text-white">
              Save up to 80%
            </BaseText>
          </div>
        </div>
        <!-- Divider -->
        <div class="hidden md:block h-0 w-full border-t border-neutral-alpha-300 my-5" />
        <a class="base-btn-dark mt-5 md:mt-0 p-2 w-full flex items-center justify-center gap-1"
        href="https://www.foreplay.co/book-demo" target="_blank">
          <BaseText type="label" size="sm">
            Talk with an expert
          </BaseText>
          <ChevronIcon class="transform -rotate-90 w-6 h-6" className="text-neutral-alpha-650" />
        </a>
      </div>
      <div class="hidden md:flex flex-col w-full py-3 px-6 justify-between">
        <div class="space-y-2.5">
          <BaseText type="label" size="sm">
            Let's discuss a tailored solution that covers unique needs.
          </BaseText>
          <div v-for="enterpriseBenefit in ENTERPRISE_BENEFITS" :key="enterpriseBenefit"
          class="w-full flex items-center gap-2 text-white">
            <CheckmarkIcon />
            <BaseText type="body" size="sm" class="flex-1">
              {{ enterpriseBenefit }}
            </BaseText>
          </div>
        </div>
        <div class="space-y-4">
          <BaseText type="label" size="sm" class="text-white my-4">
            Trusted by over 10,000 growth teams and agencies
          </BaseText>
          <div class="w-full flex items-center justify-between">
            <div v-for="company in TRUSTED_COMPANIES" :key="company">
              <img :src="company" style="width:auto; max-height: 26px">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MoneyCircleIcon from '@/components/globals/Icons/MoneyCircleIcon.vue'
import { SUBSCRIPTION_PLANS, PRODUCT_ASSETS, ENTERPRISE_BENEFITS, TRUSTED_COMPANIES } from '@/utils/stripe/productMeta'
import DarkProductCard from '@/components/account/subscription/DarkProductCard.vue'
// Icons
import ChevronIcon from '@/components/globals/Icons/ChevronIcon.vue'
import CheckmarkIcon from '@/components/globals/Icons/CheckmarkIcon.vue'
export default {
  components: {
    MoneyCircleIcon,
    DarkProductCard,
    ChevronIcon,
    CheckmarkIcon
  },
  data () {
    return {
      PRODUCT_ASSETS,
      ENTERPRISE_BENEFITS,
      TRUSTED_COMPANIES,
      activeInterval: 'monthly',
      backgroundStyle: {},
      resizeObserver: null,
      useMobileLayout: window.innerWidth < 768
    }
  },
  computed: {
    productCards () {
      if (!this.useMobileLayout) return SUBSCRIPTION_PLANS
      // Reorder the plans to put basic last in mobile layout
      return [SUBSCRIPTION_PLANS[1], SUBSCRIPTION_PLANS[2], SUBSCRIPTION_PLANS[0]]
    }
  },
  mounted(){
    this.setInterval(this.activeInterval)
    window.addEventListener('resize', this.handleWindowResize)
    this.$nextTick(() => {
      this.resizeObserver = new ResizeObserver(() => {
        this.setInterval(this.activeInterval)
      })
      this.resizeObserver.observe(this.$refs.intervalContainer)
    })
  },
  beforeDestroy () {
    if (this.resizeObserver) this.resizeObserver.disconnect()
    window.removeEventListener('resize', this.handleWindowResize)
  },
  methods: {
    handleNext (payload) {
      this.$emit('next', { step: 'plan', data: payload })
    },
    handleWindowResize () {
      this.useMobileLayout = window.innerWidth < 768
    },
    setInterval(key) {
      this.activeInterval = key;
      this.$nextTick(() => {
        const activeBtn = this.$refs?.[`${this.activeInterval}-btn`];
        const container = this.$refs.intervalContainer;
        if (activeBtn && container) {
          const btnRect = activeBtn.getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();
          this.backgroundStyle = {
            left: `${btnRect.left - containerRect.left}px`,
            top: `${btnRect.top - containerRect.top - 1}px`,
            width: `${btnRect.width}px`,
            height: `${btnRect.height}px`,
          };
        }
      });
    },
  }
}
</script>

<style scoped>
.base-btn-dark{
  background-color: rgba(255,255,255,0.1);
  border-radius: 10px;
  color: #fff;
  transition: background-color 100ms ease-in-out;
}

.base-btn-dark:hover {
  background-color: rgba(255,255,255,0.16);
}

.money-icon {
  color: #EBBE7A
}

.selected-interval-tag {
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.10);
}
</style>
